import { cn } from "@garther/ui/libs";

interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: string;
  className?: string;
}

export function Box({
  children,
  className,
  padding = "p-4 md:p-6",
  ...props
}: BoxProps) {
  return (
    <div
      className={cn(
        "bg-background-secondary rounded-none sm:rounded-md border border-border hover:shadow-md transition-all duration-200",
        padding,
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
